import colors from 'tailwindcss/colors';

// eslint-disable-next-line import/prefer-default-export
export const COLORS_MAP = {
    1: {
        primary: colors.red[400],
        secondary: colors.red[100],
    },
    2: {
        primary: colors.amber[300],
        secondary: colors.amber[100],
    },
    3: {
        primary: colors.emerald[400],
        secondary: colors.emerald[100],
    },
};
